import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchNavigatorData } from "ducks/navigationAndFooter/actionCreators";
import { RootReducerType } from "ducks/rootReducer";
import { PRIORITY_WEBSITE } from "utils/urls";
import { BUSINESS } from "routes/paths";

const useNavigationAndFooterData = () => {
  const {
    data: {
      personal_main_menu,
      business_main_menu,
      about_us,
      customer_support,
      footer_sitemap,
    },
    loading,
    error,
  } = useSelector((state: RootReducerType) => state.navigationFooterReducer);
  const dispatch = useDispatch();

  const dispatchFetchNavigationData = (): void => {
    dispatch(fetchNavigatorData());
  };

  useEffect(dispatchFetchNavigationData, []);
  return {
    data: [
      {
        title: "PERSONAL",
        link: "/",
        type: "Internal",
        popoverMenu: personal_main_menu,
      },
      {
        title: "BUSINESS",
        link: BUSINESS,
        type: "Internal",
        popoverMenu: business_main_menu,
      },
      {
        title: "PRIORITY",
        link: PRIORITY_WEBSITE,
        type: "External",
        popoverMenu: null,
      },
    ],
    rightMenuData: [
      {
        title: "ABOUT US",
        link: "/",
        type: "Internal",
        popoverMenu: about_us,
      },
      {
        title: "CUSTOMER SUPPORT",
        link: "/",
        type: "Internal",
        popoverMenu: customer_support,
      },
    ],
    footer_sitemap,
    loading,
    error,
  };
};

export default useNavigationAndFooterData;
